import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
import { AppDataContext } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import  Stripe from  '../Stripe';
import { Loader } from '../Loader';
import { ConfirmDialog } from '../ConfirmDialog';
import { Helmet } from "react-helmet";

export function Payment(props) {

   const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(false);

    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [addPayment, setAddPayment] = useState(!context.hasPayment);
    const [loaded, setLoaded] = useState(false);

    const onSubmitResults = (result) => {
        if (result.isError) {
            setErrorMessage(result.errorMessage);
            setSuccessMessage(null);
        } else if (result.data.message) {
            setErrorMessage(result.data.message);
            setSuccessMessage(null);
        } else {
            setSuccessMessage("Success! Your payment method has been saved");
            setErrorMessage(null);
            setAddPayment(false);
            context.setPayment(result.data);
        }
    }
    const onReady = () => {
        setLoaded(true);
    }
    const clickAddPayment = () => {
        setLoaded(false);
        setAddPayment(true);
        setSuccessMessage(null);
        setErrorMessage(null);
    }


    useEffect(() => {
        if (context.hasPayment)
            setAddPayment(!context.hasPayment);

    }, [context.hasPayment]);

    const clickRemovePayment = async () => {

        const url = 'api/site/removepaymentmethod/';

        const resp = await netRequest(url, {});

        if (resp.isError) {
            return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
        } else if (resp.data == null) {
            context.setPayment({ hasPayment: false });

            setAddPayment(true);
            setSuccessMessage("Your card has been removed.  You will not be able to bid until you enter a new one.");
            setErrorMessage(null);
            return null;
        } else {
            return resp.data.message;
        }
    }

    const clickHideAddPayment = () => {
        setAddPayment(false);
        setSuccessMessage(null);
        setErrorMessage(null);
    }

    return (
        <>
            <Helmet>
                <title>Payment Settings</title>
            </Helmet>
            <Loader loading={loading} />
            <ConfirmDialog cancelText="No" okText="Yes"
                okClicked={clickRemovePayment}
                id="paymentDeleteConfirmModal"
                headerText="Confirm Delete?"
            >
                Are you sure you want to delete your payment method?
            </ConfirmDialog>

            <div class="row mt-3">

            <div class="col-12 mb-1">
                <h4 class="auction-grid-header">
                    Payment Settings
                    <div class="divider mt-2"></div>
                </h4>
                </div>
                <div class="col-12 col-md-6 mb-3">

            {successMessage && <div class="alert alert-success mt-2">{successMessage}</div>}
            {errorMessage && <div class="alert alert-danger mt-2">{errorMessage}</div>}

            {!addPayment ? (
                <>
                   
                            <p>You currently have an active payment method: {context.brand} ending in {context.last4}</p>
                            <button type="button" class="btn btn-primary btn-sm me-3 mb-3" onClick={clickAddPayment}>Change Payment Method</button>
                    {/*
                    <button type="button" class="btn btn-primary btn-sm me-3 mb-3" data-bs-toggle="modal" data-bs-target="#paymentDeleteConfirmModal">
                        Delete Existing Payment Method
                    </button>
                    */}
                </>
            ) : (
                    <>
                        <Loader loading={!loaded} />
                        <Stripe onReady={onReady} onSubmitResults={onSubmitResults} alternateButton={{ buttonText: "Cancel", onButtonClicked: clickHideAddPayment }} />
                </>
                )}
                </div>
                </div>
        </>
    );

}
